//imports
import {
    ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST,
    ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    roles: [],
    roleLoading: false,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNTS_FILTERS_SEARCH_ROLES_REQUEST:
            return { ...state, roleLoading: true  }

        case ACCOUNTS_FILTERS_SEARCH_ROLES_RESULT:
            return { ...state, roleLoading: false, roles: action.payload  }

        case CLEAR_REDUX:
            return ["", "ACCOUNTS_ADVANCED_FILTERS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};